<template>
  <nav-bar title="外部钢瓶录入" />
  <Content :bottom="76">
    <van-form class="form" ref="form">
      <Field
        name="sendUnit"
        label="送检单位"
        v-model="sendUnit"
        :require="true"
        @on-blur="getBatchNo"
        :disabled="!!batchNo"
      />
      <Picker
        label="介质"
        :columns="selectValues.checkTypeList"
        :require="true"
        @confirm-values="(v) => changeMedium(v)"
        :disabled="!!batchNo"
      />
      <Field name="batchNo" label="批次号" v-model="batchNo" :disabled="true" />
    </van-form>
    <ul v-if="listData.length" class="list">
      <li v-for="item in listData" :key="item">
        <span>气瓶编号： {{ item }}</span>
        <span @click="onRemove(item)">移除</span>
      </li>
    </ul>
    <div class="empty" v-else>请录入气瓶</div>
  </Content>
  <div class="btn-conatiner van-hairline--top">
    <van-row gutter="16">
      <van-col span="12">
        <van-button
          block
          type="primary"
          native-type="button"
          :disabled="!batchNo"
          @click="show = true"
        >
          录入
        </van-button>
      </van-col>
      <van-col span="12">
        <van-button
          block
          type="primary"
          native-type="button"
          :disabled="!listData.length || loading"
          loading-text="请稍后..."
          :loading="loading"
          @click="onSubmit"
        >
          提交
        </van-button>
      </van-col>
    </van-row>
  </div>
  <CylinderForm
    v-if="show"
    v-model:show="show"
    @add="onAdd"
    :selectValues="selectValues"
    :sendUnit="sendUnit"
  />
</template>

<script setup>
import { ref, reactive, computed } from 'vue'
import { Toast, Notify } from 'vant'
import {
  cylinderPreAdd,
  getBatchNoBySendUnit,
  addOutCylinderCheck
} from '@/api/cylinderManageUserHome'
import CylinderForm from './components/CylinderForm.vue'
import { useGetData } from '@/hooks/useGetData'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()
const companyId = computed(() => store.state.roleInfo.companyId)
const empId = computed(() => store.state.roleInfo.empId)
const show = ref(false)
// 获取下拉选择值
const selectValues = reactive({
  gsMediumList: [],
  gsTypeList: [],
  makeUnitList: [],
  checkTypeList: []
})
useGetData(cylinderPreAdd, (data) => {
  for (const key in data) {
    selectValues[key] = data[key]
  }
})({ companyId: companyId.value })
const listData = ref([])
const onAdd = ({ gsCode }) => {
  show.value = false
  if (listData.value.includes(gsCode)) {
    setTimeout(() => {
      Toast('钢瓶已存在')
    })
    return
  }
  listData.value.push(gsCode)
  console.log(gsCode)
}
const onRemove = (code) => {
  listData.value = listData.value.filter((item) => item !== code)
}
const sendUnit = ref('')
const medium = ref('')
const batchNo = ref('')
const changeMedium = (val) => {
  medium.value = val.dicVal
  getBatchNo()
}
// 获取批次
const getBatchNo = async () => {
  if (medium.value && sendUnit.value) {
    Toast.loading({
      message: '获取批次...',
      forbidClick: true,
      duration: 0
    })
    const res = await getBatchNoBySendUnit({
      companyId: companyId.value,
      medium: medium.value
    })
    console.log(res)
    Toast.clear()
    batchNo.value = res.data
  }
}
const loading = ref(false)
const onSubmit = async () => {
  loading.value = true
  const data = {
    companyId: companyId.value,
    empId: empId.value,
    codeArr: listData.value.join(','),
    sendUnit: sendUnit.value,
    batchNo: batchNo.value,
    medium: medium.value
  }
  await addOutCylinderCheck(data)
  loading.value = false
  Notify({ type: 'success', message: '操作成功' })
  router.back()
}
</script>

<style lang="scss" scoped>
.empty {
  font-size: 12px;
  text-align: center;
  padding: 15px;
  color: #666;
}
.list {
  font-size: 12px;
  padding: 16px;
  li {
    padding: 16px;
    background-color: #ffffff;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    span:last-child {
      color: red;
    }
  }
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
